import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Revenue Scrub',
    entityNamePlural: 'Revenue Scrubs',
    entityNameModule: 'offer',
    menuToggle: false,
  }), [])
}
